"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElstrConfig_1 = require("./ElstrConfig");
var ElstrApplicationData_1 = require("./ElstrApplicationData");
/**
 * By default the ElstrLocalStorage as an JSON type.
 * The content can be individualized to fit the requirements of it's application
 *
 * For using localStorage without a JSON type the recommended way is to use directly
 * the localStorage API. See: https://developer.mozilla.org/de/docs/Web/API/Window/localStorage
 */
var ElstrLocalStorage = /** @class */ (function () {
    /**
     *
     * @param {object} initObj
     * @param {boolean} override override primary used for test runners to set the initLocalStorage Data
     * @param {string} storageName
     */
    function ElstrLocalStorage(initObj, override, storageName) {
        if (initObj === void 0) { initObj = {}; }
        if (override === void 0) { override = false; }
        if (storageName === void 0) { storageName = "default"; }
        // Init the Local Storage with initLocalStorage data IF the store doesn't exist
        storageName = storageName === "default" ? this.getDefaultName() : storageName;
        this._localStorageName = storageName;
        this.initLocalStorage(initObj, override, storageName);
    }
    Object.defineProperty(ElstrLocalStorage.prototype, "localStorageName", {
        get: function () {
            return this._localStorageName;
        },
        set: function (value) {
            this._localStorageName = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Init localStorage when the storage doesn't exist or override is available
     * @param {object} initLocalStorage
     * @param {string} storageName
     * @param {boolean} override
     */
    ElstrLocalStorage.prototype.initLocalStorage = function (initLocalStorage, override, storageName) {
        if (override) {
            localStorage.setItem(this.localStorageName, JSON.stringify(initLocalStorage));
        }
        // This part will ensure, that new keys will be added to the Store
        // While Existing ones won't be overridden
        for (var key in initLocalStorage) {
            this.setValueIfNotExist(key, initLocalStorage[key]);
        }
    };
    /**
     * Returns the elstr local storage already parsed as an object ready to be used further
     * Return an empty Object when failed
     * @returns {any}
     */
    ElstrLocalStorage.prototype.getElstrLocalStorage = function () {
        if (localStorage.getItem(this.localStorageName)) {
            return JSON.parse(String(localStorage.getItem(this.localStorageName)));
        }
        return {};
    };
    /**
     * Gets first level of an local storage object
     * Returns null when nothing is provided
     * @param {string} key
     * @return {any}
     */
    ElstrLocalStorage.prototype.getValue = function (key) {
        return this.getElstrLocalStorage()[key] ? this.getElstrLocalStorage()[key] : null;
    };
    /**
     * Get the obj from a storage which is stored as an object
     * Return an empty Object when failed
     * @param {string} store
     * @returns {any}
     */
    ElstrLocalStorage.prototype.getStorage = function (store) {
        if (localStorage.getItem(store)) {
            return JSON.parse(String(localStorage.getItem(store)));
        }
        return {};
    };
    /**
     * Get a Certain Value from a storage that is stored as an object
     * Returns null when nothing is provided
     * @param {string} store
     * @param {string} key
     * @returns {null}
     */
    ElstrLocalStorage.prototype.getValueFromStore = function (store, key) {
        return this.getStorage(store)[key] ? this.getStorage(store)[key] : null;
    };
    /**
     * The provided object will replace all key value pairs in the first level
     * @param obj
     */
    ElstrLocalStorage.prototype.replaceObj = function (obj) {
        var elstrLocalStorage = this.getElstrLocalStorage();
        for (var key in obj) {
            elstrLocalStorage[key] = obj[key];
        }
        localStorage.setItem(this.localStorageName, JSON.stringify(elstrLocalStorage));
        return this.getElstrLocalStorage();
    };
    /**
     * Adds the provided key value pair when the key doesn't existing in the first level
     * This prevents overwriting existing properties in the localStorage
     * @param {string} key
     * @param {string} value
     * @return {any}
     */
    ElstrLocalStorage.prototype.setValueIfNotExist = function (key, value) {
        var elstrLocalStorage = this.getElstrLocalStorage();
        // Only add when doesn't exist
        if (!elstrLocalStorage.hasOwnProperty(key)) {
            return this.replaceValue(key, value);
        }
        return this.getElstrLocalStorage();
    };
    /**
     * FOLLOWING SECTION CONTAINS HELPER FUNCTION AROUND AN ARRAY VALUES IN THE FIRST LEVEL
     * EX: obj = {someArray: [1, 2, "three"]}
     */
    /**
     * Adds the provided value to an list/array when the value isn't included in the array
     * in the targeted array.
     * Will also create the key and add the value in the array if the key doesn't exist
     * Only for first level arrays
     * @param {string} key
     * @param {number | string | null} value
     * @returns {any}
     */
    ElstrLocalStorage.prototype.setValueToArrayIfNotExist = function (key, value) {
        var arr = this.getValue(key);
        // Create array if arr is null because we wan't to the value to an array
        if (arr === null)
            arr = [];
        // Only add when doesn't exist
        if (!arr.includes(value) && value !== null) {
            arr.push(value);
            return this.replaceValue(key, arr);
        }
        return this.getElstrLocalStorage();
    };
    /**
     * Attempts to remove an item from a list
     * @param {string} key
     * @param {number | string | null} value
     * @returns {any}
     */
    ElstrLocalStorage.prototype.removeValueFromArray = function (key, value) {
        var elstrLocalStorage = this.getElstrLocalStorage();
        var list = elstrLocalStorage[key];
        if (list.indexOf(value) !== -1 && value !== null) {
            // Delete the one element from the ist
            list.splice(list.indexOf(value), 1);
            // Specified to have null instead of an empty array
            if (list.length === 0)
                list = null;
            return this.replaceValue(key, list);
        }
        return this.getElstrLocalStorage();
    };
    /**
     * Replace first level with the provided key value pair
     * @param {string} key
     * @param {string} value
     * @return {any}
     */
    ElstrLocalStorage.prototype.replaceValue = function (key, value) {
        var elstrLocalStorage = this.getElstrLocalStorage();
        elstrLocalStorage[key] = value;
        localStorage.setItem(this.localStorageName, JSON.stringify(elstrLocalStorage));
        return this.getElstrLocalStorage();
    };
    /**
     * Gets the def name for the storage in dev and production
     * The name can be overridden in the config.ini
     * @returns {any}
     */
    ElstrLocalStorage.prototype.getDefaultName = function () {
        if (
        // Access directly from the window data
        ElstrApplicationData_1.configExists() &&
            window.ELSTR.applicationData.config.localStorageName) {
            return window.ELSTR.applicationData.config.localStorageName;
        }
        else if (ElstrConfig_1.config("localStorageName") !== null) {
            // If window data is already empty try to access the config
            return ElstrConfig_1.config("localStorageName");
        }
        else {
            // Return Fallback
            if (process.env.NODE_ENV === "production")
                return "ElstrApp";
            return "ElstrAppDev";
        }
    };
    return ElstrLocalStorage;
}());
exports.default = ElstrLocalStorage;
//# sourceMappingURL=ElstrLocalStorage.js.map